/* eslint-disable eqeqeq */
import React, { useState, useContext, useEffect } from "react";
import { Button, DropdownButton, Image, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import PayrollFilterCard from "./PayrollFilterCard";
import { ProgressBar, LoaderWrapper } from "../../../components";
import PayrollAndCensusData from "../../../mocks/payrollAndCensusData.json";
import {
  MANAGE_PAYROLL_ROUTES,
  getPathWithParam,
  ROUTES,
  PAYROLL_RECORDS_TO_FETCH,
  getAdvancedPathWithParam,
  FLOW_TYPES,
  EMPLOYEE_RECORDS_TO_FETCH,
  usDateFormat,
} from "../../../utils";
import {
  downloadPayrollReport,
  deleteUploadedFile,
  getPayrollDetailsAction,
  managePayrollStore,
  refreshPayrollDetails,
  clearFormDataLocalCache,
  setManagePayrollFullPageData,
  appLayoutStore,
} from "../../../contexts";
import PayrollCard from "./PayrollCard";
import { isEmpty, get, values } from "lodash";
import ExcelImage from "../../../styles/exportimg.PNG";
import { faRedoAlt, faCheck } from "@fortawesome/pro-regular-svg-icons";
import { useDeepEffect } from "../../../abstracts";
import InfiniteScroll from "react-infinite-scroller";
import authService from "../../../components/api-authorization/AuthorizeService";
import * as fileSaver from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const today = new Date();
const toDate = usDateFormat(today);
const fromDate = usDateFormat(new Date(today.setDate(today.getDate() - 60)));
const fileStatusMap = {
  3: "ErrorCorrectionRequired",
  4: "PendingSubmission",
  5: "AwaitingFunding",
  1: "CreationInProgress",
};

const ManagePayrollContainer = (props) => {
  const { history } = props;
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const [activeButton, setActiveButton] = useState([]);
  const { state, dispatch } = useContext(managePayrollStore);
  let payrollFilters = get(state, "payrollFilters", null);
  const [prevbtn, setPrevbtn] = useState(payrollFilters?.fileStatus ?? []);
  const [fieldValues, setFieldValues] = useState(
    payrollFilters || {
      companyId: 0,
      planId: 0,
      toDate: toDate,
      fromDate: fromDate,
      itemsAlreadyFetched: 0,
      fileStatus: [],
      recordsToFetch: PAYROLL_RECORDS_TO_FETCH,
      searchString: "",
    }
  );
  const [refresh, setRefresh] = useState(true);
  const [payrollFilterLoading, setPayrollFilterLoading] = useState(false);
  const testData = [{ bgcolor: "#219653", completed: 75 }];
  const formdata = get(state, "api.fileuploadData", []);
  const payrollData = formdata;
  console.log("formdata", formdata);
  const Loading = get(state, "api.isFetching", false);
  const payrollStatuses = get(state, "uploadedFileStatuses", {});
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const prepareFieldValues = (values) => {
    return {
      ...values,
      fromDate: values.fromDate,
      toDate: values.toDate,
      paydateFrom: values.paydateFrom,
      paydateTo: values.paydateTo,
      companyId: values.companyId ? parseInt(values.companyId) : 0,
      companyName: values.companyName ? values.companyName : "",
      planId: values.planId ? parseInt(values.planId) : 0,
      fileStatus: values.fileStatus ? values.fileStatus : [],
      searchString: values.searchString ? values.searchString : "",
      timeZoneOffset: new Date().getTimezoneOffset(),
    };
  };
  const obj = get(payrollStatuses, "obj", 0);
  useDeepEffect(() => {
    if (fieldValues.itemsAlreadyFetched !== 0) {
      dispatch(
        getPayrollDetailsAction(
          prepareFieldValues(fieldValues),
          dispatch,
          state
        )
      );
    }
  }, [fieldValues.itemsAlreadyFetched]);

  useDeepEffect(() => {
    setFieldValues({
      ...fieldValues,
      itemsAlreadyFetched: 0,
      recordsToFetch: PAYROLL_RECORDS_TO_FETCH,
    });
    dispatch(
      refreshPayrollDetails(
        prepareFieldValues({
          ...fieldValues,
          itemsAlreadyFetched: 0,
          recordsToFetch: PAYROLL_RECORDS_TO_FETCH,
        }),
        dispatch,
        state
      )
    );
    var activebuttons = [];
    for (const fileStatus of fieldValues.fileStatus) {
      activebuttons.push(fileStatusMap[fileStatus]);
    }
    setActiveButton(activebuttons);
    dispatch(setManagePayrollFullPageData(fieldValues));
    setStopInfiniteScroll(false);
  }, [refresh]);
  useDeepEffect(
    () => setStopInfiniteScroll(get(payrollStatuses, "stopTrigger", false)),
    [payrollStatuses]
  );

  const selectButtons = (btnName) => {
    activeButton.push(btnName);
  };
  const removeButtons = (btnName) => {
    var buttons = activeButton.filter((_) => _ != btnName);
    setActiveButton(buttons);
  };

  const nextPage = (id, tabNo, amount) => {
    history.push(
      getPathWithParam({
        path: ROUTES.PAYROLL_FILE_STATUS,
        pathParam: [id],
        queryParam: `?tab=${tabNo}&amount=${amount}`,
      })
    );
  };
  const deleteFile = (id) => {
    deleteUploadedFile(id);
  };
  const pageRefresh = () => {
    setRefresh(!refresh);
  };
  const exportReportFile = () => {
    // var req=({ ...fieldValues,companyName:values[fields.companyName]})
    downloadPayrollReport(
      prepareFieldValues({
        ...fieldValues,
      })
    )
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          //"PayrollSummary.xlsx"
          `Payroll Summary Report_ ${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };
  const filterTile = (statusid) => {
    if (prevbtn.length === 0 || !prevbtn.some((_) => _ === statusid)) {
      prevbtn.push(statusid);
      dispatch(clearFormDataLocalCache());
      setFieldValues((fieldValues) => {
        return {
          ...fieldValues,
          fileStatus: prevbtn,
          itemsAlreadyFetched: 0,
        };
      });
      pageRefresh();
    }
  };
  const removeFilter = (statusid) => {
    if (prevbtn.length != 0 && prevbtn.some((_) => _ === statusid)) {
      var updatedstatus = (prevbtn || []).filter((_) => _ != statusid);
      setPrevbtn(updatedstatus);
      dispatch(clearFormDataLocalCache());
      setFieldValues((fieldValues) => {
        return {
          ...fieldValues,
          fileStatus: updatedstatus,
          itemsAlreadyFetched: 0,
        };
      });
      pageRefresh();
    }
  };
  const columns = [
    {
      // label: "File name & details",
      style: { paddingLeft: "13px", fontSize: "14px", width: "25%" },
      className: "grey-text font-weight-700",
    },
    {
      // label: "Plan details",
      style: { fontSize: "14px", width: "22%" },
      className: "grey-text font-weight-700",
    },
    {
      // label: "Profile name",
      style: { fontSize: "14px", width: "18%" },
      className: "grey-text font-weight-700",
    },
    {
      // label: "Total Amount",
      style: { fontSize: "14px", width: "10%", marginTop: "15px" },
      className: "grey-text font-weight-700",
    },
    {
      // label: "Status",
      style: { fontSize: "14px", width: "20%" },
      className: "grey-text font-weight-700",
    },
    {
      // label: "Action",
      style: {
        fontSize: "14px",
        width: "5%",
      },
      className: "grey-text font-weight-700",
    },
  ];

  return (
    <LoaderWrapper isLoading={Loading}>
      <div className="payroll-container w-100">
        {/* <div className="d-flex justify-content-between align-baseline">
          <div className="plan-heading font-weight-500">Payroll & Census</div>
          {permissions[roleName].menuItems["payroll"].includes("C") && (
            <div className="mt-10">
              <DropdownButton
                title="New Payroll"
                style={{ width: "180px" }}
                align="end"
                id="dropdown-menu-align-end"
                className={"request-dropdown"}
              >
                <Dropdown.Item>
                  <Link to={MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD}>
                    Standard
                  </Link>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item>
                  <Link to={MANAGE_PAYROLL_ROUTES.BASIC_INFORMATION}>
                    One-Time
                  </Link>
                </Dropdown.Item>
              </DropdownButton>
            </div>
          )}
        </div> */}
        <div className="border-top" />
        <PayrollFilterCard
          refresh={refresh}
          setFieldValues={setFieldValues}
          fieldValues={fieldValues}
          pageRefresh={pageRefresh}
          setLoading={setPayrollFilterLoading}
          setPrevbtn={setPrevbtn}
          selectButtons={selectButtons}
          dispatcher={dispatch}
          clearForm={clearFormDataLocalCache}
          payrollFilters={payrollFilters}
          setStopInfiniteScroll={setStopInfiniteScroll}
        />
        <div className="d-flex">
          <div
            className={`${
              activeButton.some((_) => _ === "ErrorCorrectionRequired")
                ? `class${2} active`
                : `class${2}`
            } d-flex justify-content-between mt-10`}
            onClick={() => {
              if (!activeButton.some((_) => _ === "ErrorCorrectionRequired")) {
                selectButtons("ErrorCorrectionRequired");
                filterTile(3);
              } else {
                removeButtons("ErrorCorrectionRequired");
                removeFilter(3);
              }
            }}
          >
            {activeButton.some((_) => _ === "ErrorCorrectionRequired") && (
              <div className="width-20">
                <FontAwesomeIcon icon={faCheck} />
              </div>
            )}
            <div>Error Corrections required</div>
            <div
              className={
                activeButton.some((_) => _ === "ErrorCorrectionRequired")
                  ? ""
                  : "error-text"
              }
            >
              {get(payrollStatuses, "errorCorrection", 0)}
            </div>
          </div>
          <div
            className={`${
              activeButton.some((_) => _ === "PendingSubmission")
                ? `class${3} active`
                : `class${3}`
            } d-flex justify-content-between mt-10`}
            onClick={() => {
              if (!activeButton.some((_) => _ === "PendingSubmission")) {
                selectButtons("PendingSubmission");
                filterTile(4);
              } else {
                removeButtons("PendingSubmission");
                removeFilter(4);
              }
            }}
          >
            {activeButton.some((_) => _ === "PendingSubmission") && (
              <div className="width-20">
                <FontAwesomeIcon icon={faCheck} />
              </div>
            )}
            <div>Pending Submission</div>
            <div
              className={
                activeButton.some((_) => _ === "PendingSubmission")
                  ? ""
                  : "pending-text"
              }
            >
              {get(payrollStatuses, "pendingSubmission", 0)}
            </div>
          </div>
          <div
            className={`${
              activeButton.some((_) => _ === "CreationInProgress")
                ? `class${1} active`
                : `class${1}`
            } d-flex justify-content-between mt-10`}
            onClick={() => {
              if (!activeButton.some((_) => _ === "CreationInProgress")) {
                selectButtons("CreationInProgress");
                filterTile(1);
              } else {
                removeButtons("CreationInProgress");
                removeFilter(1);
              }
            }}
          >
            {activeButton.some((_) => _ === "CreationInProgress") && (
              <div className="width-20">
                <FontAwesomeIcon icon={faCheck} />
              </div>
            )}
            <div>Creation In progress</div>
            <div
              className={
                activeButton.some((_) => _ === "CreationInProgress")
                  ? ""
                  : "creation-text"
              }
            >
              {get(payrollStatuses, "creationInProgress", 0)}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-space-between">
          <div style={{ marginTop: "10px", width: "870px" }}>
            <div>
              <p className="files-list-text">Recently Added/Modified</p>
            </div>
            <div className="grey-text" style={{ marginTop: "5px" }}>
              <p
                className="grey-text"
                style={{
                  fontSize: "12px",
                  marginBottom: "0px",
                }}
              >
                {payrollData?.length ?? 0} /{" "}
                {isEmpty(fieldValues.fileStatus)
                  ? get(payrollStatuses, "total", 0)
                  : fieldValues.fileStatus.length >= 1 &&
                    fieldValues.fileStatus.reduce(
                      (e, i) => e + (obj[i] ?? 0),
                      0
                    )}{" "}
                Records found
              </p>
            </div>
          </div>
          <div>
            <span
              className="mr-2 mt-12 sort-button cursor-pointer payroll-btns"
              style={{ lineHeight: "19px" }}
              onClick={() => exportReportFile()}
            >
              <Image src={ExcelImage} width="20px" />
              <u>Export</u>
            </span>
            <span
              className="ml-2 mt-12 sort-button cursor-pointer payroll-btns primary-small"
              style={{ lineHeight: "19px" }}
              onClick={() => {
                setRefresh(!refresh);
              }}
            >
              <FontAwesomeIcon icon={faRedoAlt} className="mr-2" />
              <u>Refresh</u>
            </span>
          </div>
        </div>
        {/* <div className="line-separator" style={{ marginBottom: "0px" }} /> */}
        {/* <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "10px",
            marginTop: "0px",
          }}
        > 
         
           </div> */}

        <div
          style={{
            display: "flex",
            marginBottom: "10px",
            marginTop: "15px",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          {columns.map((_) => (
            <div className={_.className} style={{ ..._.style }}>
              {" "}
              {_.label}
            </div>
          ))}
        </div>
        <div className="file-list">
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              if (formdata?.length != 0) {
                setFieldValues((fieldValues) => {
                  return {
                    ...fieldValues,
                    itemsAlreadyFetched: formdata?.length,
                  };
                });
              }
            }}
            hasMore={!stopInfiniteScroll}
            initialLoad={false}
            threshold={100}
            useWindow={false}
            loader={
              Loading &&
              formdata?.length !== 0 && (
                <div className="loader" key={0}>
                  Loading ...
                </div>
              )
            }
          >
            {/* <div className="fil-upload">
          <Row>
            <Col md="3">
              <Image src={require("../../../styles/upload.png")} />
              <OverlayTrigger
                overlay={<Tooltip>ABC-CA 2020FEDHJAIEIEONCOBA.xls</Tooltip>}
              >
                <span className="excel-text ft-14">
                  ABC-CA 2020FEBA<span className="grey-text ft-10">.xls</span>
                </span>
              </OverlayTrigger>
            </Col>
            <Col md="3">
              <span className="ft-12 font-weight-500 grey-text mr-4">
                17:59
              </span>
              <span className="ft-12 font-weight-500 grey-text mr-4">
                02/01/2020
              </span>
              <span className="ft-12 font-weight-500 dark-grey-text mr-4">
                {" "}
                5 minutes ago
              </span>
            </Col>
            <Col md="6">
              {testData.map((item, idx) => (
                <ProgressBar
                  key={idx}
                  bgcolor={item.bgcolor}
                  completed={item.completed}
                />
              ))}
            </Col>
          </Row>
        </div> */}
            {formdata != null ? (
              // activeButton != "" ? (
              //   !isEmpty(
              //     formdata.filter(
              //       (payroll) => payroll.fileStatus == activeButton
              //     )
              //   ) ? (
              //     formdata
              //       .filter((payroll) => payroll.fileStatus == activeButton)
              //       .map((data, index) => (
              //         <PayrollCard
              //           index={index}
              //           data={data}
              //           history={history}
              //           fixError={() => nextPage(data.id, 2, data.totalAmount)}
              //           deleteUploadFile={() =>
              //             deleteFile(data.id, data.totalAmount)
              //           }
              //           Submit={() => nextPage(data.id, 3, data.totalAmount)}
              //           AwaitingFunding={() =>
              //             nextPage(data.id, 4, data.totalAmount)
              //           }
              //           pageRefresh={pageRefresh}
              //         />
              //       ))
              //   ) : Loading || payrollFilterLoading ? (
              //     ""
              //   ) : (
              //     <span>No results found</span>
              //   )
              // ) :
              <div>
                {!isEmpty(payrollData) ? (
                  payrollData?.map((data, index) => (
                    <PayrollCard
                      index={index}
                      data={data}
                      history={history}
                      fixError={() => nextPage(data.id, 2, data.totalAmount)}
                      deleteUploadFile={() =>
                        deleteFile(data.id, data.totalAmount)
                      }
                      Submit={() => nextPage(data.id, 3, data.totalAmount)}
                      AwaitingFunding={() =>
                        nextPage(data.id, 4, data.totalAmount)
                      }
                      Continue={() =>
                        history.push(
                          getAdvancedPathWithParam({
                            path: MANAGE_PAYROLL_ROUTES.CREATE_PAYROLL_LISTING,
                            pathParam: [FLOW_TYPES.EDIT, data.id],
                          })
                        )
                      }
                      setLoading={setPayrollFilterLoading}
                      pageRefresh={pageRefresh}
                      columns={columns}
                    />
                  ))
                ) : Loading || payrollFilterLoading ? (
                  ""
                ) : (
                  <span>No results found</span>
                )}
              </div>
            ) : null}
          </InfiniteScroll>
        </div>
      </div>
    </LoaderWrapper>
  );
};

export default ManagePayrollContainer;
